import { useState, useEffect } from "react";
import { findNextIndex, findPrevIndex } from "../helpers";

const useBuffer = ({ list, doFetch, setItem, isOnlyOneItem = false, id = "row_id", returnLastUpdate = false }) => {
    const [index, setIndex] = useState(null);
    const [buffer, setBuffer] = useState([]);

    const parseResponse = res => {
        if (returnLastUpdate) {
            return {
                ...res
            }
        } else {
            return {
                data: res
            }
        }
    }

    const asyncFetch = async (param = {}) => {
        const { loader, refetch = false, refetchCurr = false, cbAfterFirstRequest, cbAfterAllRequest } = param;
        if (index !== null && index > -1) {
            let resCurr, resPrev, resNext;
            const currItem = list[index];
            const nextItem = list[findNextIndex(index, list)];
            const prevItem = list[findPrevIndex(index, list)];
            const itemFromBuffer = buffer.find(item => item && item[id] === currItem[id]);

            if(refetch && !refetchCurr) {
                setBuffer([]);
            }

            if (itemFromBuffer === undefined || refetch || refetchCurr) {
                const res = await doFetch({
                    item: currItem,
                    returnLastUpdate,
                    loader
                });
                resCurr = parseResponse(res);
                const data = { [id]: currItem[id], ...resCurr };
                setItem(data);
                if(refetchCurr) {
                    setBuffer(prevBuffer => {
                        return prevBuffer.map(prevBufferItem => {
                            if (prevBufferItem[id] === data[id]) {
                                return data
                            } else {
                                return prevBufferItem
                            }
                        })
                    })
                }
                cbAfterFirstRequest && cbAfterFirstRequest();
            } else {
                setItem(itemFromBuffer);
            }

            if (!refetchCurr) {
                const prevItemFromBuffer = buffer.find(item => item && item[id] === prevItem[id])
                const nextItemFromBuffer = buffer.find(item => item && item[id] === nextItem[id])

                if (prevItemFromBuffer !== undefined && nextItemFromBuffer !== undefined && !refetch) {
                    setBuffer([prevItemFromBuffer, nextItemFromBuffer, resCurr ? { [id]: currItem[id], ...resCurr } : itemFromBuffer])
                } else if (nextItemFromBuffer !== undefined && !refetch) {
                    setBuffer([nextItemFromBuffer, resCurr ? { [id]: currItem[id], ...resCurr } : itemFromBuffer])
                } else if (prevItemFromBuffer !== undefined && !refetch) {
                    setBuffer([prevItemFromBuffer, resCurr ? { [id]: currItem[id], ...resCurr } : itemFromBuffer])
                }

                if ((nextItemFromBuffer === undefined || refetch) && nextItem[id] !== currItem[id]) {
                    const res = await doFetch({
                        item: nextItem,
                        loader: false,
                        returnLastUpdate
                    });
                    resNext = parseResponse(res);
                    if (prevItemFromBuffer !== undefined && !refetch) {
                        setBuffer([prevItemFromBuffer, { [id]: nextItem[id], ...resNext }, resCurr ? { [id]: currItem[id], ...resCurr } : itemFromBuffer])
                    } else {
                        setBuffer([{ [id]: nextItem[id], ...resNext }, resCurr ? { [id]: currItem[id], ...resCurr } : itemFromBuffer])
                    }
                }

                if ((prevItemFromBuffer === undefined || refetch) && prevItem[id] !== currItem[id] && prevItem[id] !== nextItem[id]) {
                    const res = await doFetch({
                        item: prevItem,
                        loader: false,
                        returnLastUpdate
                    });
                    resPrev = parseResponse(res);
                    if (nextItemFromBuffer !== undefined && !refetch) {
                        setBuffer([{ [id]: prevItem[id], ...resPrev }, nextItemFromBuffer, resCurr ? { [id]: currItem[id], ...resCurr } : itemFromBuffer])
                    } else {
                        setBuffer([{ [id]: prevItem[id], ...resPrev }, { [id]: nextItem[id], ...resNext }, resCurr ? { [id]: currItem[id], ...resCurr } : itemFromBuffer])
                    }
                }
            }

            cbAfterAllRequest && cbAfterAllRequest();
        } else if (isOnlyOneItem) {
            const res = await doFetch({
                loader: loader !== undefined ? loader : true,
                returnLastUpdate
            });
            const resCurr = parseResponse(res);
            setItem(resCurr);
        }
    }

    useEffect(() => {
        asyncFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index, isOnlyOneItem])

    const refetchBuffer = param => {
        return asyncFetch({ ...param, refetch: true })
    }

    const onClickPrevItem = () => {
        const prevIndex = findPrevIndex(index, list)
        setIndex(prevIndex)
    }

    const onClickNextItem = () => {
        const nextIndex = findNextIndex(index, list)
        setIndex(nextIndex)
    }

    return {
        index,
        setIndex,
        refetchBuffer,
        onClickPrevItem,
        onClickNextItem
    }
}

export default useBuffer